import {EventArtist} from "../type/eventArtist";
import {EventInstructor} from "../type/eventInstructor";

export const toSlots = (event_artists: EventArtist[], event_instructors: EventInstructor[]) => [
    ...event_artists.map(ea => ({ ...ea, slotType: "artist" })),
    ...event_instructors.map(ei => ({ ...ei, slotType: "instructor" }))
].sort((a, b) => (a.time || "").localeCompare(b.time || ""));